function Version() {
  return null;
}

export default Version;
